var _circle, _circle2, _circle3, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlanet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.999 511.999",
    style: {
      enableBackground: "new 0 0 511.999 511.999"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#394049"
    },
    d: "M8.586,354.599c-3.064,0-5.94-1.891-7.049-4.936c-9.503-26.108,26.875-57.756,59.065-79.71 c42.898-29.256,103.234-58.729,169.89-82.99c66.657-24.261,131.822-40.466,183.488-45.629c38.77-3.874,86.981-3.014,96.483,23.094 c1.416,3.893-0.591,8.196-4.482,9.613c-3.898,1.415-8.197-0.592-9.613-4.482c-3.631-9.975-26.787-18.708-80.895-13.299 c-50.461,5.043-114.333,20.953-179.85,44.799c-65.518,23.846-124.673,52.714-166.569,81.287 c-44.925,30.638-57.052,52.212-53.421,62.187c1.417,3.893-0.59,8.196-4.482,9.613C10.303,354.453,9.437,354.599,8.586,354.599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED6EA4"
    },
    d: "M249.809,148.235c-42.85-42.85-112.38-42.758-155.116,0.274 c-42.641,42.937-41.676,112.62,1.113,155.409l129.755,129.755c13.391,13.391,35.103,13.391,48.494,0l129.756-129.755 c42.789-42.789,43.755-112.472,1.114-155.409C362.189,105.477,292.659,105.385,249.809,148.235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.12,
      enableBackground: "new"
    },
    d: "M404.926,148.509c-16.72-16.836-37.542-27.098-59.263-30.788 c12.596,5.381,24.392,13.225,34.643,23.547c42.641,42.937,41.676,112.62-1.114,155.409L249.437,426.433 c-5.844,5.844-13.272,9.136-20.902,9.88c13.46,10.677,33.081,9.803,45.522-2.639l129.756-129.755 C446.601,261.129,447.567,191.447,404.926,148.509z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#394049"
    },
    d: "M262.12,253.842c-4.648,0-8.927-1.609-12.31-4.3c-3.383,2.69-7.662,4.3-12.31,4.3 c-10.923,0-19.81-8.886-19.81-19.81c0-4.142,3.357-7.5,7.5-7.5s7.5,3.357,7.5,7.5c0,2.652,2.158,4.811,4.81,4.811 s4.81-2.158,4.81-4.811c0-4.142,3.357-7.5,7.5-7.5c4.142,0,7.5,3.357,7.5,7.5c0,2.652,2.158,4.811,4.81,4.811 s4.809-2.158,4.809-4.811c0-4.142,3.357-7.5,7.5-7.5s7.5,3.357,7.5,7.5C281.929,244.955,273.042,253.842,262.12,253.842z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#394049"
    },
    d: "M337.057,233.671c-4.143,0-7.5-3.357-7.5-7.5v-6.387c0-4.143,3.357-7.5,7.5-7.5 c4.142,0,7.5,3.357,7.5,7.5v6.387C344.557,230.313,341.2,233.671,337.057,233.671z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#394049"
    },
    d: "M162.562,233.671c-4.143,0-7.5-3.357-7.5-7.5v-6.387c0-4.143,3.357-7.5,7.5-7.5 c4.142,0,7.5,3.357,7.5,7.5v6.387C170.062,230.313,166.704,233.671,162.562,233.671z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M169.67,260.72h-14.217c-4.143,0-7.5-3.357-7.5-7.5c0-4.142,3.357-7.5,7.5-7.5h14.217 c4.142,0,7.5,3.357,7.5,7.5C177.17,257.362,173.813,260.72,169.67,260.72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M344.167,260.72H329.95c-4.142,0-7.5-3.357-7.5-7.5c0-4.142,3.357-7.5,7.5-7.5h14.217 c4.143,0,7.5,3.357,7.5,7.5C351.666,257.362,348.309,260.72,344.167,260.72z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#394049"
    },
    d: "M66.559,374.458c-29.859,0-58.001-5.509-65.022-24.795c-1.416-3.892,0.591-8.196,4.482-9.613 c3.896-1.415,8.196,0.591,9.613,4.482c3.631,9.975,26.789,18.706,80.895,13.299c50.461-5.043,114.333-20.953,179.85-44.8 c65.518-23.846,124.672-52.714,166.57-81.287c44.924-30.638,57.051-52.212,53.42-62.186c-1.417-3.892,0.59-8.196,4.482-9.613 c3.89-1.416,8.196,0.589,9.613,4.482c9.503,26.107-26.875,57.755-59.065,79.709c-42.898,29.256-103.234,58.729-169.89,82.99 s-131.821,40.466-183.488,45.63C87.891,373.768,77.117,374.458,66.559,374.458z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFABCA"
    },
    cx: 448.67,
    cy: 236.91,
    r: 34.942
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 439.62,
    cy: 222.98,
    r: 7.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 469.62,
    cy: 226.53,
    r: 7.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 454.62,
    cy: 253.22,
    r: 7.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4D06D"
    },
    d: "M71.101,84.096H52.953V65.949c0-4.143-3.357-7.5-7.5-7.5c-4.142,0-7.5,3.357-7.5,7.5v18.148H19.805 c-4.143,0-7.5,3.357-7.5,7.5s3.357,7.5,7.5,7.5h18.148v18.148c0,4.143,3.357,7.5,7.5,7.5c4.142,0,7.5-3.357,7.5-7.5V99.096h18.148 c4.143,0,7.5-3.357,7.5-7.5C78.6,87.454,75.243,84.096,71.101,84.096z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4D06D"
    },
    d: "M499.963,395.512h-18.148v-18.148c0-4.143-3.357-7.5-7.5-7.5c-4.142,0-7.5,3.357-7.5,7.5v18.148 h-18.148c-4.142,0-7.5,3.357-7.5,7.5s3.357,7.5,7.5,7.5h18.148v18.148c0,4.142,3.357,7.5,7.5,7.5s7.5-3.357,7.5-7.5v-18.148h18.148 c4.143,0,7.5-3.357,7.5-7.5S504.106,395.512,499.963,395.512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4D06D"
    },
    d: "M439.374,49.879h-18.148V31.731c0-4.142-3.357-7.5-7.5-7.5s-7.5,3.357-7.5,7.5v18.148h-18.148 c-4.142,0-7.5,3.357-7.5,7.5c0,4.142,3.357,7.5,7.5,7.5h18.148v18.148c0,4.142,3.357,7.5,7.5,7.5c4.142,0,7.5-3.357,7.5-7.5V64.879 h18.148c4.143,0,7.5-3.358,7.5-7.5S443.516,49.879,439.374,49.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4D06D"
    },
    d: "M111.587,447.121H93.439v-18.148c0-4.142-3.357-7.5-7.5-7.5s-7.5,3.357-7.5,7.5v18.148H60.291 c-4.142,0-7.5,3.357-7.5,7.5s3.357,7.5,7.5,7.5h18.148v18.148c0,4.142,3.357,7.499,7.5,7.499c4.142,0,7.5-3.357,7.5-7.499v-18.148 h18.148c4.142,0,7.5-3.357,7.5-7.5C119.087,450.478,115.729,447.121,111.587,447.121z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanet);
export default __webpack_public_path__ + "static/media/planet.fd6f4469.svg";
export { ForwardRef as ReactComponent };